import Axios from "@/plugins/Axios";
import store from "@/store";
import Serie from "@/Models/Serie";

export class SeriesService {
  async atualizarSerie(serie) {
    const response = await Axios().put(`series/${serie.id}`, serie);

    return response.data;
  }

  async criarSerie(serie) {
    const response = await Axios().post("series", serie);

    return response.data;
  }

  async deletarSerie(serie) {
    const response = await Axios().delete(`series/${serie.id}`);

    return response.data;
  }

  async getDisciplinasComGestao(serieId) {
    const response = await Axios().get(`series/disciplinas-com-gestao/${serieId}`);

    return response.data;
  }

  async getSerie(serie_id) {
    const response = await Axios().get(`series/${serie_id}`);

    return response.data.serie;
  }

  async recuperarSerie(serie) {
    return this.atualizarSerie({ ...serie, deleted_at: null });
  }

  async syncAll() {
    const response = await Axios().get("series");

    const series = response.data.map((serie) => new Serie(serie));
    return series;
  }

  async syncAllPaginated(pageNumber, query) {
    const response = await Axios().get(`series/paginate?page=${pageNumber}&query=${query}`);

    return response.data;
  }
}

export default new SeriesService();
